<div>
	<div class="d-flex mb-4">
		<div class="h3 m-2">
			<span> Dealers </span>
		</div>
	</div>

	<div class="d-flex mb-2">
		<div class="p-col-12">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-shopping-cart"></i>
					</span>
					<span class="overview-title">Dealers</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-3 vertical-divider">
						<div class="overview-number">
							<span *ngIf="dealerListComponent.dealerList">
								{{ dealerListComponent.dealerList.length }}
							</span>
							<span *ngIf="!dealerListComponent.dealerList">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Dealers</div>
					</div>
					<div class="col-3 vertical-divider">
						<div class="overview-number">
							<span *ngIf="dealerListComponent.dealerList">
								{{ dealerListComponent.venues }}
							</span>
							<span *ngIf="!dealerListComponent.dealerList">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Venues</div>
					</div>
					<div class="col-3 vertical-divider">
						<div class="overview-number">
							<span *ngIf="dealerListComponent.dealerList">
								{{ dealerListComponent.licensedVenues }}
							</span>
							<span *ngIf="!dealerListComponent.dealerList">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Licensed Venues</div>
					</div>
					<div class="col-3">
						<div class="overview-number">
							<span *ngIf="dealerListComponent.dealerList">
								{{ dealerListComponent.focusLinkLicenses.length }}
							</span>
							<span *ngIf="!dealerListComponent.dealerList">
								<p-skeleton></p-skeleton>
							</span>
						</div>
						<div class="overview-subtext">Link Licenses</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="card">
		<app-dealer-list #dealerListComponent (dealerIdSelectedEmitter)="dealerIdSelected = $event"></app-dealer-list>
		<app-dealer-setup *ngIf="dealerIdSelected" [(dealerIdSelected)]="dealerIdSelected"></app-dealer-setup>
	</div>
</div>
